import React from 'react';
import { Box, Typography, Button } from '@mui/material';

/**
 * A component to display an error message when the Data Sources table fails to load.
 * @param {object} props - The component props.
 * @param {() => void} props.onRefresh - The function to call when the refresh button is clicked.
 * @returns {JSX.Element} The rendered component.
 */
const ErrorDSTableDisplay = ({ onRefresh }: { onRefresh: () => void; }) => (
  <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    p: 3,
    height: '100%',
    backgroundColor: '#FFFFFF', // Assuming a white background
  }}>
    {/* IMPORTANT: Replace this src path with the actual path to your error image.
      For example, if it's in your public/icons folder, the path might be "/icons/hourglass-error.svg".
    */}
    <img 
      src="/usmerror.svg" // Make sure this path is correct
      alt="Error loading data" 
      style={{ width: '130px', marginBottom: '16px' }} 
    />
    <Typography variant="h6" component="h2" sx={{ fontWeight: 600, color: '#333333', mb: 1, fontSize:'16px',fontFamily:'Inter',lineHeight:'20px' }}>
      Unable to Display Data
    </Typography>
    <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '450px', mb: 2, fontFamily: 'Inter',fontWeight: 400, color: '#333333', fontSize:'12px',lineHeight:'20px' }}>
      We're currently experiencing a temporary issue displaying the data.
      please try refreshing the page or check back shortly.
    </Typography>
          <Button
            variant="text"
            onClick={onRefresh}
            sx={{
                textTransform: 'none',
                color: '#0064FF',
                fontWeight: 500,
                fontFamily:'Inter',
                lineHeight:'21px',
                fontSize:'14px'
            }}
            >
            Refresh Page
            </Button>
  </Box>
);

export default ErrorDSTableDisplay;
